"use strict";
exports["2dde1a8"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizImapTitleText","properties":{"imapServer":{"type":"string","title":"LabelImapServer","default":"outlook.office365.com","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},"security":{"type":"string","title":"LabelSecurityType","default":"SSL","enum":["SSL","TLS"]},"authenticationType":{"type":"string","title":"LabelAuthenticationType","default":"OAuth","enum":["OAuth","Basic"],"enumNames":["AuthenticationTypeOAuth","AuthenticationTypeBasic"]},"ignoreTrustForSsl":{"type":"boolean","title":"LabelIgnoreTrustForSsl","default":false},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["imapServer","security","authenticationType","notice","proofOfWork"],"dependencies":{"security":{"oneOf":[{"properties":{"security":{"enum":["SSL"]},"sslPort":{"type":"number","title":"LabelPopImapPort","default":993}},"required":["sslPort"]},{"properties":{"security":{"enum":["TLS"]},"tlsPort":{"type":"number","title":"LabelPopImapPort","default":143}},"required":["tlsPort"]}]},"authenticationType":{"oneOf":[{"properties":{"authenticationType":{"enum":["OAuth"]},"oAuthCredential":{"type":"object","title":"OAuthCredentialsLabel"},"alternateMailbox":{"type":"string","title":"LabelImapAlternateMailbox","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^\\s*$"}},"required":["oAuthCredential"]},{"properties":{"authenticationType":{"enum":["Basic"]},"basicAuthNotice":{"type":"object","title":"","properties":{},"required":[]},"userName":{"type":"string","title":"LabelImapUsername","maxLength":250},"password":{"type":"string","title":"LabelPassword"}},"required":["basicAuthNotice","userName","password"]}]}},"$id":"2dde1a8"};
const pattern0 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^\\s*$", "u");
const pattern1 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");
const func2 = require("ajv/dist/runtime/ucs2length").default;

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="2dde1a8" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.imapServer === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "imapServer"},message:"must have required property '"+"imapServer"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.security === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "security"},message:"must have required property '"+"security"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.authenticationType === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "authenticationType"},message:"must have required property '"+"authenticationType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.notice === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.proofOfWork === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.security !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.sslPort === undefined){
const err5 = {instancePath,schemaPath:"#/dependencies/security/oneOf/0/required",keyword:"required",params:{missingProperty: "sslPort"},message:"must have required property '"+"sslPort"+"'",schema:schema11.dependencies.security.oneOf[0].required,parentSchema:schema11.dependencies.security.oneOf[0],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "SSL")){
const err6 = {instancePath:instancePath+"/security",schemaPath:"#/dependencies/security/oneOf/0/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.security.oneOf[0].properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.security.oneOf[0].properties.security.enum,parentSchema:schema11.dependencies.security.oneOf[0].properties.security,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.sslPort !== undefined){
let data1 = data.sslPort;
if(!(typeof data1 == "number")){
const err7 = {instancePath:instancePath+"/sslPort",schemaPath:"#/dependencies/security/oneOf/0/properties/sslPort/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.dependencies.security.oneOf[0].properties.sslPort.type,parentSchema:schema11.dependencies.security.oneOf[0].properties.sslPort,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.tlsPort === undefined){
const err8 = {instancePath,schemaPath:"#/dependencies/security/oneOf/1/required",keyword:"required",params:{missingProperty: "tlsPort"},message:"must have required property '"+"tlsPort"+"'",schema:schema11.dependencies.security.oneOf[1].required,parentSchema:schema11.dependencies.security.oneOf[1],data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.security !== undefined){
let data2 = data.security;
if(!(data2 === "TLS")){
const err9 = {instancePath:instancePath+"/security",schemaPath:"#/dependencies/security/oneOf/1/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.security.oneOf[1].properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.security.oneOf[1].properties.security.enum,parentSchema:schema11.dependencies.security.oneOf[1].properties.security,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.tlsPort !== undefined){
let data3 = data.tlsPort;
if(!(typeof data3 == "number")){
const err10 = {instancePath:instancePath+"/tlsPort",schemaPath:"#/dependencies/security/oneOf/1/properties/tlsPort/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.dependencies.security.oneOf[1].properties.tlsPort.type,parentSchema:schema11.dependencies.security.oneOf[1].properties.tlsPort,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err11 = {instancePath,schemaPath:"#/dependencies/security/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.security.oneOf,parentSchema:schema11.dependencies.security,data};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.authenticationType !== undefined){
const _errs12 = errors;
let valid4 = false;
let passing1 = null;
const _errs13 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err12 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/0/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.dependencies.authenticationType.oneOf[0].required,parentSchema:schema11.dependencies.authenticationType.oneOf[0],data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.authenticationType !== undefined){
let data4 = data.authenticationType;
if(!(data4 === "OAuth")){
const err13 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.authenticationType,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.oAuthCredential !== undefined){
let data5 = data.oAuthCredential;
if(!(data5 && typeof data5 == "object" && !Array.isArray(data5))){
const err14 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.oAuthCredential,data:data5};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.alternateMailbox !== undefined){
let data6 = data.alternateMailbox;
if(typeof data6 === "string"){
if(!pattern0.test(data6)){
const err15 = {instancePath:instancePath+"/alternateMailbox",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/alternateMailbox/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^\\s*$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^\\s*$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$|^\\s*$",parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.alternateMailbox,data:data6};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/alternateMailbox",schemaPath:"#/dependencies/authenticationType/oneOf/0/properties/alternateMailbox/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[0].properties.alternateMailbox.type,parentSchema:schema11.dependencies.authenticationType.oneOf[0].properties.alternateMailbox,data:data6};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
var _valid1 = _errs13 === errors;
if(_valid1){
valid4 = true;
passing1 = 0;
}
const _errs19 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.basicAuthNotice === undefined){
const err17 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "basicAuthNotice"},message:"must have required property '"+"basicAuthNotice"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.userName === undefined){
const err18 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.password === undefined){
const err19 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf/1/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.dependencies.authenticationType.oneOf[1].required,parentSchema:schema11.dependencies.authenticationType.oneOf[1],data};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.authenticationType !== undefined){
let data7 = data.authenticationType;
if(!(data7 === "Basic")){
const err20 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType.enum,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.authenticationType,data:data7};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.basicAuthNotice !== undefined){
let data8 = data.basicAuthNotice;
if(!(data8 && typeof data8 == "object" && !Array.isArray(data8))){
const err21 = {instancePath:instancePath+"/basicAuthNotice",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/basicAuthNotice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.basicAuthNotice,data:data8};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.userName !== undefined){
let data9 = data.userName;
if(typeof data9 === "string"){
if(func2(data9) > 250){
const err22 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters",schema:250,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data9};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/userName",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.userName.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.userName,data:data9};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.password !== undefined){
let data10 = data.password;
if(typeof data10 !== "string"){
const err24 = {instancePath:instancePath+"/password",schemaPath:"#/dependencies/authenticationType/oneOf/1/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.authenticationType.oneOf[1].properties.password.type,parentSchema:schema11.dependencies.authenticationType.oneOf[1].properties.password,data:data10};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
var _valid1 = _errs19 === errors;
if(_valid1 && valid4){
valid4 = false;
passing1 = [passing1, 1];
}
else {
if(_valid1){
valid4 = true;
passing1 = 1;
}
}
if(!valid4){
const err25 = {instancePath,schemaPath:"#/dependencies/authenticationType/oneOf",keyword:"oneOf",params:{passingSchemas: passing1},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.authenticationType.oneOf,parentSchema:schema11.dependencies.authenticationType,data};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
else {
errors = _errs12;
if(vErrors !== null){
if(_errs12){
vErrors.length = _errs12;
}
else {
vErrors = null;
}
}
}
}
if(data.imapServer !== undefined){
let data11 = data.imapServer;
if(typeof data11 === "string"){
if(!pattern1.test(data11)){
const err26 = {instancePath:instancePath+"/imapServer",schemaPath:"#/properties/imapServer/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.properties.imapServer,data:data11};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/imapServer",schemaPath:"#/properties/imapServer/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.imapServer.type,parentSchema:schema11.properties.imapServer,data:data11};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.security !== undefined){
let data12 = data.security;
if(typeof data12 !== "string"){
const err28 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.security.type,parentSchema:schema11.properties.security,data:data12};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!((data12 === "SSL") || (data12 === "TLS"))){
const err29 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.security.enum,parentSchema:schema11.properties.security,data:data12};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.authenticationType !== undefined){
let data13 = data.authenticationType;
if(typeof data13 !== "string"){
const err30 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.authenticationType.type,parentSchema:schema11.properties.authenticationType,data:data13};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(!((data13 === "OAuth") || (data13 === "Basic"))){
const err31 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema11.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.authenticationType.enum,parentSchema:schema11.properties.authenticationType,data:data13};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data.ignoreTrustForSsl !== undefined){
let data14 = data.ignoreTrustForSsl;
if(typeof data14 !== "boolean"){
const err32 = {instancePath:instancePath+"/ignoreTrustForSsl",schemaPath:"#/properties/ignoreTrustForSsl/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.ignoreTrustForSsl.type,parentSchema:schema11.properties.ignoreTrustForSsl,data:data14};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.notice !== undefined){
let data15 = data.notice;
if(data15 && typeof data15 == "object" && !Array.isArray(data15)){
if(data15.testAccountConsent === undefined){
const err33 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data15};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data15.testAccountConsent !== undefined){
let data16 = data15.testAccountConsent;
if(typeof data16 !== "boolean"){
const err34 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data16};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data15};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data17 = data.proofOfWork;
if(typeof data17 !== "string"){
const err36 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data17};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-5405303b"] = validate11;
const schema12 = {"type":"object","properties":{"security":{"enum":["SSL"]}},"$id":"-5405303b"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-5405303b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "SSL")){
const err0 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema12.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.security.enum,parentSchema:schema12.properties.security,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["4e494836"] = validate12;
const schema13 = {"type":"object","properties":{"security":{"enum":["TLS"]}},"$id":"4e494836"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="4e494836" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "TLS")){
const err0 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema13.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.security.enum,parentSchema:schema13.properties.security,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}

exports["249b33cc"] = validate13;
const schema14 = {"type":"object","properties":{"authenticationType":{"enum":["OAuth"]}},"$id":"249b33cc"};

function validate13(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="249b33cc" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "OAuth")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema14.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema14.properties.authenticationType.enum,parentSchema:schema14.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema14.type,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate13.errors = vErrors;
return errors === 0;
}

exports["-3625bd4b"] = validate14;
const schema15 = {"type":"object","properties":{"authenticationType":{"enum":["Basic"]}},"$id":"-3625bd4b"};

function validate14(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-3625bd4b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authenticationType !== undefined){
let data0 = data.authenticationType;
if(!(data0 === "Basic")){
const err0 = {instancePath:instancePath+"/authenticationType",schemaPath:"#/properties/authenticationType/enum",keyword:"enum",params:{allowedValues: schema15.properties.authenticationType.enum},message:"must be equal to one of the allowed values",schema:schema15.properties.authenticationType.enum,parentSchema:schema15.properties.authenticationType,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema15.type,parentSchema:schema15,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate14.errors = vErrors;
return errors === 0;
}
